import { Sidebar } from '@/components/common/sidebar';
import { Outlet, LoaderFunctionArgs } from 'react-router';
import { Header } from '@/components/common/header';
import { clubApi } from '@repo/api-client';
import { useCurrentClub } from '@/hooks/use-current-club';
import { PortalHost } from '@repo/ui/components/portal';

function AppLayout() {
  const club = useCurrentClub();

  return (
    <div className="flex h-full w-full">
      <Sidebar club={club} />
      <main className="flex flex-1 flex-col">
        <Header />
        <div className="h-full max-h-[calc(100vh-45px)] overflow-y-auto p-4">
          <Outlet />
        </div>
        <PortalHost id="portal-footer" />
      </main>
    </div>
  );
}

const loader = async ({ params }: LoaderFunctionArgs) => {
  const [club, clubs] = await Promise.all([clubApi.getById(params.id as string), clubApi.getAll()]);
  return { club, clubs: clubs.results };
};

export const id = 'app-layout';

export const route = {
  id,
  element: <AppLayout />,
  loader,
};
